import Image from "next/image"
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import { NavigationItem } from "types/navigation"

export default function ImageGrid({
  items,
  title,
}: {
  items: NavigationItem[]
  title?: string
}) {
  return (
    <div>
      {title && (
        <h3 className="text-[13px] font-bold text-brand-navy uppercase tracking-wide mb-2 pb-1 border-b border-gray-200">
          {title}
        </h3>
      )}
      <div className="grid grid-cols-5 gap-3">
        {items.map((item) => (
          <LocalizedClientLink
            key={item.id}
            href={item.url}
            className="group text-center"
          >
            {item.image_url ? (
              <div className="bg-gray-50 rounded overflow-hidden mb-1.5 aspect-square">
                <Image
                  src={item.image_url}
                  alt={item.label}
                  width={120}
                  height={120}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200"
                />
              </div>
            ) : (
              <div className="bg-gray-100 rounded mb-1.5 aspect-square flex items-center justify-center">
                <span className="text-gray-400 text-[11px]">{item.label}</span>
              </div>
            )}
            <span className="text-[11px] text-gray-700 group-hover:text-brand-primary font-medium leading-tight block">
              {item.label}
            </span>
          </LocalizedClientLink>
        ))}
      </div>
    </div>
  )
}
